import { redirect } from '@tanstack/react-router'
import { consumeRedirectTo, setRedirectTo } from '../../utils/auth-redirect'

export const requireAuth = ({ context, location }) => {
  if (context?.auth?.isLoadingLogin) return
  if (!context?.auth?.isLoggedIn) {
    setRedirectTo(location?.href)
    throw redirect({ to: '/login' })
  }
}

export const redirectIfAuthenticated = ({ context }) => {
  if (context?.auth?.isLoadingLogin) return
  if (context?.auth?.isLoggedIn) {
    const redirectTo = consumeRedirectTo()
    // `href` for the stored path (it may include a query string); `to` for the
    // literal fallback.
    throw redirect(redirectTo ? { href: redirectTo } : { to: '/project' })
  }
}
